import { render, staticRenderFns } from "./lading-page-relatorio-repasse.vue?vue&type=template&id=58ad7c82&scoped=true&"
import script from "./lading-page-relatorio-repasse.vue?vue&type=script&lang=js&"
export * from "./lading-page-relatorio-repasse.vue?vue&type=script&lang=js&"
import style0 from "./lading-page-relatorio-repasse.vue?vue&type=style&index=0&id=58ad7c82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ad7c82",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCol,VContainer,VDataTable,VDivider,VRow,VSimpleTable})
